export class PharmacyLicense {
  id!: number;
  pharmacy_id!: number;
  name!: string;
  active!: boolean;
  number!: string;
  signed_url!: string;
  expires_on!: string;
  created_at!: string;
  updated_at!: string;

  public constructor(init?: Partial<Record<string, unknown>>) {
    Object.assign(this, init);
  }
}
